import { defineRule } from 'vee-validate';

export default defineNuxtPlugin((nuxtApp) => {
  const { $i18n } = nuxtApp;

  defineRule('required', (value: string) => {
    if (!value || !value.length) {
      return $i18n.t('www_field_required');
    }
    return true;
  });
})
